import { Button, Modal } from 'react-bootstrap';
import { MatchViewModel } from '../../backend/entryPoints/mapper/mapToMatchViewModel';
import { useEffect, useState } from 'react';

function IntervalModal(props: {
    visible: boolean;
    interval: boolean;
    handleClose: () => void;
    setServerReceiver: (
        servingSide: number,
        server: number,
        receiver: number,
        playerStartingPosition: number[][]
    ) => void;
    match: MatchViewModel | undefined;
}) {
    const [servingSide, setServingSide] = useState<number[]>(); // positioning of the serving team
    const [receivingSide, setReceivingSide] = useState<number[]>(); // positioning of the receiving team
    const [selectedServerButton, setSelectedServerButton] = useState<number>(-1);
    const [selectedReceiverButton, setSelectedReceiverButton] = useState<number>(-1);
    const [server, setServer] = useState<number>(-1);
    const [receiver, setReceiver] = useState<number>(-1);
    const [time, setTime] = useState<number>(120);
    const [intervalRefId, setIntervalRefId] = useState<any>(null);

    useEffect(() => {
        setServer(-1);
        setReceiver(-1);
        setSelectedServerButton(-1);
        setSelectedReceiverButton(-1);
        setServingSide(undefined);
        setReceivingSide(undefined);
    }, [props.match]);

    useEffect(() => {
        if (props.interval) {
            setTime(120);
            const intervalID = setInterval(() => {
                setTime((prevTime) => {
                    if (prevTime <= 1) {
                        clearInterval(intervalRefId);
                        return 0;
                    }
                    return prevTime - 1;
                });
            }, 1000);
            setIntervalRefId(intervalID);
        }
    }, [props.visible]);

    const getTimeFromSeconds = () => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
    };

    // initial setup of server and receiver
    // format if home team serves first: [odd, even] -> [0,1] or [1,0]
    // format if guest team serves first: [even, odd] -> [2,3] or [3,2]
    const handleServerChange = (playerIndex: number, buttonIdx: number) => {
        if (props.match === undefined) return;
        setServingSide(
            props.match.serving_team === 0
                ? [playerIndex === 0 ? 1 : 0, playerIndex]
                : [playerIndex, playerIndex === 2 ? 3 : 2]
        );
        setServer(playerIndex);
        setSelectedServerButton(buttonIdx);
    };

    // initial setup of server and receiver
    // format if home team serves first: [odd, even] -> [0,1] or [1,0]
    // format if guest team serves first: [even, odd] -> [2,3] or [3,2]
    const handleReceiverChange = (playerIndex: number, buttonIdx: number) => {
        if (props.match === undefined) return;
        setReceivingSide(
            props.match.serving_team === 0
                ? [playerIndex, playerIndex === 2 ? 3 : 2]
                : [playerIndex === 0 ? 1 : 0, playerIndex]
        );
        setReceiver(playerIndex);
        setSelectedReceiverButton(buttonIdx);
    };

    const determinePlayerPosition = () => {
        if (props.match === undefined)
            return [
                [-1, -1],
                [-1, -1],
            ];
        if (servingSide === undefined || receivingSide === undefined)
            return [
                [-1, -1],
                [-1, -1],
            ];
        if (props.match.mode === 0) {
            return [
                [-1, 0],
                [2, -1],
            ];
        }
        return props.match.serving_team === 0 ? [servingSide, receivingSide] : [receivingSide, servingSide];
    };

    return (
        <Modal
            show={props.visible}
            onHide={() => {
                clearInterval(intervalRefId);
                props.handleClose();
            }}
            size={'lg'}
        >
            <Modal.Header>
                <Modal.Title>Interval</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {props.interval ? (
                    <div style={{ textAlign: 'center' }}>
                        <h2>Timer</h2>
                        <text style={{ fontSize: '40px' }}>{getTimeFromSeconds()}</text>
                    </div>
                ) : null}
                {props.match?.mode === 0 ? (
                    <p>The game is a singles match. Hence, nothing to do here.</p>
                ) : (
                    <>
                        <p>Please select the server and receiver for the current game.</p>
                        <table style={{ width: '100%' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '20%' }}>
                                        <text>
                                            Select a <b>Server</b>
                                        </text>
                                    </td>
                                    <td>
                                        <Button
                                            size={'lg'}
                                            style={{ width: '30%', marginRight: '20px' }}
                                            className={selectedServerButton === 2 ? 'selected-working-day-btn' : ''}
                                            onClick={() =>
                                                handleServerChange(props.match?.serving_team === 0 ? 0 : 2, 2)
                                            }
                                        >
                                            {props.match !== undefined
                                                ? props.match.serving_team === 0
                                                    ? props.match.player_home[0]
                                                    : props.match.player_guest[0]
                                                : 'Player 1'}
                                        </Button>
                                        <Button
                                            size={'lg'}
                                            style={{ width: '30%' }}
                                            className={selectedServerButton === 13 ? 'selected-working-day-btn' : ''}
                                            onClick={() =>
                                                handleServerChange(props.match?.serving_team === 0 ? 1 : 3, 13)
                                            }
                                        >
                                            {props.match !== undefined
                                                ? props.match.serving_team === 0
                                                    ? props.match.player_home[1]
                                                    : props.match.player_guest[1]
                                                : 'Player 3'}
                                        </Button>
                                    </td>
                                </tr>
                                <tr style={{ width: '20%' }}>
                                    <td>
                                        <text>
                                            Select a <b>Receiver</b>
                                        </text>
                                    </td>
                                    <td>
                                        <Button
                                            size={'lg'}
                                            style={{ width: '30%', marginTop: '20px', marginRight: '20px' }}
                                            className={selectedReceiverButton === 20 ? 'selected-working-day-btn' : ''}
                                            onClick={() =>
                                                handleReceiverChange(props.match?.serving_team === 0 ? 2 : 0, 20)
                                            }
                                        >
                                            {props.match !== undefined
                                                ? props.match.serving_team === 0
                                                    ? props.match.player_guest[0]
                                                    : props.match.player_home[0]
                                                : 'Player 2'}
                                        </Button>
                                        <Button
                                            size={'lg'}
                                            style={{ width: '30%', marginTop: '20px' }}
                                            className={selectedReceiverButton === 31 ? 'selected-working-day-btn' : ''}
                                            onClick={() =>
                                                handleReceiverChange(props.match?.serving_team === 0 ? 3 : 1, 31)
                                            }
                                        >
                                            {props.match !== undefined
                                                ? props.match.serving_team === 0
                                                    ? props.match.player_guest[1]
                                                    : props.match.player_home[1]
                                                : 'Player 4'}
                                        </Button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button
                    className="btn btn-secondary"
                    disabled={(server === -1 || receiver === -1) && props.match?.mode === 1}
                    onClick={() => {
                        if (props.match?.mode === 1) {
                            props.setServerReceiver(
                                props.match?.serving_team ?? 0,
                                server,
                                receiver,
                                determinePlayerPosition()
                            );
                        }
                        clearInterval(intervalRefId);
                        props.handleClose();
                    }}
                >
                    {props.match?.mode === 0 ? 'Close' : 'Save'}
                </button>
                {props.match?.mode === 1 ? (
                    <button
                        className={'btn btn-secondary'}
                        onClick={() => {
                            props.handleClose();
                            clearInterval(intervalRefId);
                        }}
                    >
                        Close
                    </button>
                ) : null}
            </Modal.Footer>
        </Modal>
    );
}

export default IntervalModal;
